import React, { useState } from 'react';
import { useDarkMode } from './hooks/useDarkMode';
import { useAuth } from './hooks/useAuth';
import { LoginPage } from './pages/LoginPage';
import { KPITracker } from './pages/KPITracker';
import { CalendarPage } from './pages/CalendarPage';
import { SettingsPage } from './pages/SettingsPage';
import { Header } from './components/Header';
import { Sidebar } from './components/Sidebar';
import { StatsCard } from './components/StatsCard';
import { ContactsTable } from './components/ContactsTable';
import { Users, UserPlus, CheckCircle, TrendingUp } from 'lucide-react';
export function App() {
  const {
    isDark,
    toggleDark
  } = useDarkMode();
  const {
    isAuthenticated,
    user,
    isLoading,
    login,
    logout
  } = useAuth();
  const [currentPage, setCurrentPage] = useState('home');
  if (isLoading) {
    return <div className="flex h-screen w-full items-center justify-center bg-background" data-id="element-0">
        <div className="text-center" data-id="element-1">
          <div className="h-8 w-8 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" data-id="element-2"></div>
          <p className="text-muted-foreground" data-id="element-3">Wird geladen...</p>
        </div>
      </div>;
  }
  if (!isAuthenticated) {
    return <LoginPage onLogin={login} data-id="element-4" />;
  }
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <div className="p-6 space-y-6" data-id="element-5">
            <div data-id="element-6">
              <h1 className="text-3xl font-bold text-foreground" data-id="element-7">Dashboard</h1>
              <p className="text-muted-foreground mt-1" data-id="element-8">
                Willkommen zurück, {user?.name}! Hier ist Ihre Speedscaling CRM
                Übersicht.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-9">
              <div onClick={() => setCurrentPage('contacts')} className="cursor-pointer" data-id="element-10">
                <StatsCard title="Gesamtkontakte" value="2,847" change="+12% seit letztem Monat" trend="up" icon={Users} data-id="element-11" />
              </div>
              <div onClick={() => setCurrentPage('contacts')} className="cursor-pointer" data-id="element-12">
                <StatsCard title="Neue diese Woche" value="127" change="+8% seit letzter Woche" trend="up" icon={UserPlus} data-id="element-13" />
              </div>
              <div onClick={() => setCurrentPage('kpi')} className="cursor-pointer" data-id="element-14">
                <StatsCard title="Offene Aufgaben" value="43" change="-15% seit gestern" trend="down" icon={CheckCircle} data-id="element-15" />
              </div>
              <div onClick={() => setCurrentPage('kpi')} className="cursor-pointer" data-id="element-16">
                <StatsCard title="Abschlussrate" value="68%" change="+5% seit letztem Monat" trend="up" icon={TrendingUp} data-id="element-17" />
              </div>
            </div>

            <ContactsTable onContactClick={id => console.log('Contact clicked:', id)} data-id="element-18" />
          </div>;
      case 'contacts':
        return <div className="p-6 space-y-6" data-id="element-19">
            <div data-id="element-20">
              <h1 className="text-3xl font-bold text-foreground" data-id="element-21">Kontakte</h1>
              <p className="text-muted-foreground mt-1" data-id="element-22">
                Alle Ihre Kundenkontakte im Überblick
              </p>
            </div>
            <ContactsTable onContactClick={id => console.log('Contact clicked:', id)} data-id="element-23" />
          </div>;
      case 'kpi':
        return <KPITracker data-id="element-24" />;
      case 'calendar':
        return <CalendarPage data-id="element-25" />;
      case 'settings':
        return <SettingsPage data-id="element-26" />;
      default:
        return <div className="p-6" data-id="element-27">
            <h1 className="text-3xl font-bold text-foreground" data-id="element-28">
              Seite nicht gefunden
            </h1>
          </div>;
    }
  };
  return <div className="flex h-screen w-full bg-background overflow-hidden" data-id="element-29">
      <Sidebar currentPage={currentPage} onNavigate={setCurrentPage} data-id="element-30" />

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-31">
        <Header isDark={isDark} toggleDark={toggleDark} onLogout={logout} userName={user?.name} data-id="element-32" />

        <main className="flex-1 overflow-y-auto" data-id="element-33">{renderPage()}</main>
      </div>
    </div>;
}